<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-6">
                        <h3>REPORTE DE DESPACHOS</h3>
                    </div>
                    <div class="col-6 text-right">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos"><i class="fas fa-filter"></i> Filtrar</button>
                        <button class="btn btn-success btn-icon" @click="exportar_excel"><i class="fas fa-file-excel"></i> Excel</button>
                    </div>
                </div>
                
                <div class="accordion" id="accordionExample">
              <div class="card">
                <div
                  class="card-header background-blue-2"
                  id="headingOne"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  <h5 class="mb-0">FILTROS</h5>
                </div>
                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                    <div class="col-8">
                        <div
                          class="table-responsive"
                          style="height: 450px; border: 1px solid #3c3c3c"
                        >
                          <table class="table">
                            <tr>
                              <th
                                class="background-light"
                                style="padding: 0.5em"
                              >
                                RANGO DE FECHAS
                              </th>
                              <td style="padding: 0.5em">
                                <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                              </td>
                            </tr>

                            <tr>
                              <th
                                class="background-light"
                                style="padding: 0.5em"
                              >
                                TICKET
                              </th>
                              <td style="padding: 0.5em">
                                <input
                                  type="number"
                                  name=""
                                  id=""
                                  v-model="codigo_ticket"
                                />
                              </td>
                            </tr>

                            <tr>
                              <th
                                class="background-light"
                                style="padding: 0.5em"
                              >
                                GUÍA
                              </th>
                              <td style="padding: 0.5em">
                                <input
                                  type="number"
                                  name=""
                                  id=""
                                  v-model="numero_guia"
                                />
                              </td>
                            </tr>

                            <tr>
                              <th
                                class="background-light"
                                style="padding: 0.5em"
                              >
                                TIPO DESPACHO
                              </th>
                              <td style="padding: 0.5em">
                                <select class="" name="" id="" v-model="tipo_despacho_id">
                                        <option value="">--Sin Seleccion--</option>
                                        <option :value="item.id" v-for="item in tipo_despachos" :key="item.id">{{item.nombre}}</option>
                                    </select>
                              </td>
                            </tr>

                            <tr>
                              <th
                                class="background-light"
                                style="padding: 0.5em"
                              >
                                PRODUCTO
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="option => option.id" v-model="productos_ids" :options="retornar_productos()" label="producto" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th
                                class="background-light"
                                style="padding: 0.5em"
                              >
                                EMPRESA DESTINO
                              </th>
                              <td style="padding: 0.5em">
                                <!-- <select name="" id="" v-model="empresas_ids">
                                        <option value="">--Sin Seleccion--</option>
                                        <option :value="item.id" v-for="item in empresas" :key="item.id">{{item.nombre}}</option>
                                    </select> -->
                                    <v-select class="" :reduce="option => option.id" v-model="empresas_ids" :options="empresas" label="nombre">
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                              </td>
                            </tr>

                            <tr>
                              <th
                                class="background-light"
                                style="padding: 0.5em"
                              >
                                SUCURSAL DESTINO
                              </th>
                              <td style="padding: 0.5em">
                                <v-select class="" :reduce="option => option.id" v-model="dependencias_ids" :options="retornar_sucursales()" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div class="col">
                        <div
                          class="table-responsive"
                          style="height: 450px; border: 1px solid #3c3c3c"
                        >
                          <table class="table">
                            <tr class="thead-skyblue2 fixed-default">
                              <th :colspan="columnas.length">
                                <label class="margen-1" for=""
                                  ><input
                                    type="checkbox"
                                    id=""
                                    value=""
                                    v-model="todos"
                                    @change="setearTodos"
                                  />
                                  Todos</label
                                >
                              </th>
                            </tr>

                            <tr v-for="col in columnas" :key="col.label">
                              <td style="padding: 0.5em">
                                <label class="margen-1" for=""
                                  ><input
                                    type="checkbox"
                                    id=""
                                    value=""
                                    v-model="col.show"
                                  />
                                  {{ col.label }}</label
                                >
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                </div>
                  </div>
                </div>
              </div>
            </div>
                
                <!-- <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="form-control-label">Seleccione un Rango de Fechas</label>
                            <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                        </div>
                    </div>

                    <div class="col">
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Materia Prima</label>
                            <v-select class="" :reduce="option => option.id" v-model="mps_id" :options="materias_primas" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Proveedores</label>
                            <v-select class="" :reduce="option => option.id" v-model="empresas_id" :closeOnSelect="false" :options="proveedores" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="col">
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Especie</label>
                            <v-select class="" :reduce="option => option.id" v-model="especies_id" :options="especies" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="col">
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Producto</label>
                            <v-select class="" :reduce="option => option.id" v-model="productos_ids" :options="productos" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="col">
                        
                        <div class="form-group">
                            <label for="form-control-label">Seleccione Destino</label>
                            <v-select class="" :reduce="option => option.id" v-model="destinos_id" :options="destinos" label="nombre" multiple>
                                <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="col">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos">Cargar</button>
                        <button class="btn btn-success btn-icon" @click="exportar_excel">Excel</button>
                    </div>
                </div> -->


                

                <!-- <div class="row">
                    <div class="col">
                        <label class="" for="" ><input type="checkbox" id="" value="" v-model="todos" @change="setearTodos"> Todos</label>

                        <label class="" for="" v-for="col in columnas" :key="col.label"><input type="checkbox" id="" value="" v-model="col.show"> {{col.label}}</label>

                        
                    </div>
                </div> -->

                <!-- <div class="row" v-for="mp in mps_parametros" :key="mp.id">
                    <div class="col">


                    <div class="accordion" id="accordionExample">
                        <div class="card">
                                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse" :data-target="`#collapse${mp.id}`" aria-expanded="false" aria-controls="collapseOne">
                                    <h5 class="mb-0">{{mp.nombre}}</h5>
                                </div>
                                <div :id="`collapse${mp.id}`" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div class="card-body">
                                    
                                         <div class="row">
                                            <div class="col">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered">
                                                        <tr class="" v-for="analisis in mp.analisis" :key="analisis.id">
                                                            <th :colspan="mp.length" class="thead-skyblue2">
                                                                {{analisis.nombre}}
                                                            </th>
                                                            <td v-for="p in analisis.parametros" :key="p.id">
                                                                <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="p.check"> {{p.nombre}}</label>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                
                                                


                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <pre>{{mps_parametros_seleccionados}}</pre>
                        </div>
                    </div>


                    </div>
                </div> -->

                <div class="row mt-1">
                    <div class="col">
                            <div class="tableFixHead" style="width:100%">
                                <table class="table table-bordered">
                                    <thead class="">
                                        <tr>
                                            
                                            <th class="fixed thead-skyblue2 text-center" v-for="c in columnas" :key="c.label" v-show="c.show">{{c.label}}</th>
                                        </tr>
                                        <!-- <tr>
                                            <th class="fixed-2"></th>
                                            <th class="fixed-2 text-center" v-for="m in mps_seleccionadas" :key="m.id">
                                                <table>
                                                    <tr>
                                                        <td style="width:100%">C/R</td>
                                                        <td style="width:100%">S/R</td>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr> -->
                                    </thead>
                                    <tbody>
                                        <tr v-for="d in datos" :key="d.id" v-bind:class="{'background-red-2':d.restricciones != null,'background-light':d.seleccionado == 1}">
                                            
                                            <td class="text-center" v-for="c in columnas" :key="c.label" v-show="c.show" @click="d.seleccionado == 1?d.seleccionado= 0:d.seleccionado=1">
                                                



                                                <span v-if="c.tipo == 'numero'">
                                                    {{ devuelve_valor(d,c.path,c.tipo)| formatear_miles}}
                                                </span>

                                                <span v-if="c.tipo == 'string' || c.tipo == 'datetime' || c.tipo == 'time' || c.tipo == 'date'">
                                                    {{devuelve_valor(d,c.path,c.tipo)}}
                                                </span>
                                                
                                                <span v-if="c.path == 'declaracion_jurada'">
                                                    <button v-show="c.path == 'declaracion_jurada' && d.declaracion_jurada != null" class="btn btn-primary btn-sm" type="button" @click="abrirDeclaracion(d)">
                                                        <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                                                    </button>
                                                </span>

                                                <span v-if="c.path == 'cam'">
                                                    <button v-show="c.path == 'cam' && d.cam != null" class="btn btn-warning btn-sm" type="button" @click="abrirCam(d)">
                                                        <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                                                    </button>
                                                </span>

                                                <span v-if="c.path != 'declaracion_jurada' && c.path !='cam'">
                                                    <button v-show="c.path == 'numero_guia'" class="btn btn-danger btn-sm" type="button" @click="abrirPdf(d)">
                                                        <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                                                    </button>
                                                </span>

                                                

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col">
                        <table class="table table-bordered">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">TOTAL PESO INFORMADO (KG)</th>
                                    <th class="text-center">TOTAL PESO RECIBIDO (KG)</th>
                                    <th class="text-center">TOTAL PESO DISTRIBUCIÓN (KG)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="total_resultado">
                                    <td class="text-center">{{total_resultado.total_peso_informado | formatear_miles}}</td>
                                    <td class="text-center">{{total_resultado.total_peso_recibido | formatear_miles}}</td>
                                    <td class="text-center">{{total_resultado.total_distribucion | formatear_miles}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> -->

                <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->
                <!-- <pre>{{fechas}}</pre> -->
                <!-- <pre>{{total_resultado}}</pre> -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fechas:[],
        tipo_despachos:[],
        tipo_despacho_id:"",
        codigo_ticket:"",
        numero_guia:"",
        productos:[],
        productos_ids:[],
        empresas:[],
        empresas_ids:"",
        dependencias:[],
        dependencias_ids:[],
        url_excel:null,



        todos:true,
        columnas:[
            //{show:true,label:'Fecha Ticket',tipo:'datetime',path:'fecha_hora_ticket'},
            {show:true, label:'Fecha Ticket', tipo:'date', path:'fecha_hora_ticket', ancho_excel: 22},
            {show:true,label:'Hora Ticket',tipo:'time',path:'fecha_hora_ticket', ancho_excel: 22},
            {show:true,label:'N° Ticket',tipo:'string',path:'codigo_ticket', ancho_excel: 19},
            {show:true,label:'Patente',tipo:'string',path:'patente', ancho_excel: 22},
            {show:true,label:'Empresa Transporte',tipo:'string',path:'empresa_transporte', ancho_excel: 31},
            {show:true,label:'Fecha Guía',tipo:'datetime',path:'fecha_guia', ancho_excel: 22},
            {show:true,label:'N° Guía',tipo:'string',path:'numero_guia', ancho_excel: 22},
            {show:true,label:'Empresa Destino',tipo:'string',path:'empresa', ancho_excel: 31},
            {show:true,label:'Sucursal Destino',tipo:'string',path:'sucursal', ancho_excel: 31},
            {show:true,label:'Tipo Despacho',tipo:'string',path:'tipo_despacho', ancho_excel: 22},
            {show:true,label:'Producto',tipo:'string',path:'producto', ancho_excel: 25},
            {show:true,label:'Peso Informado Guía (kg)',tipo:'numero',path:'peso_informado', ancho_excel: 19},
            {show:true,label:'Peso Guía (Romana)',tipo:'numero',path:'peso_real', ancho_excel: 19},
            {show:true,label:'Cantidad Romana (Kg)',tipo:'numero',path:'cantidad_producto_kg', ancho_excel: 19},

        ],
        datos:[],
    }),
    mounted(){
        this.cargar_tipo_despachos();
    },
    methods:{
        async cargar_tipo_despachos(){
          await this.axios.get(`${this.api}/tipo_despachos`,this.cabeceras_json,).then(res=>{
                this.tipo_despachos = res.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_productos_despachos();
        },

        async cargar_productos_despachos(){
          await this.axios.get(`${this.api}/producto_despachos?limit=999999999`,this.cabeceras_json,).then(res=>{
                this.productos = res.data.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_empresas_despachos();
        },

        

        async cargar_empresas_despachos(){
            await this.axios.get(`${this.api}/empresas_despachos`,this.cabeceras_json).then((res)=>{
            this.empresas = res.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          this.cargar_dependencias_despachos();
        },

        async cargar_dependencias_despachos(){
            await this.axios.get(`${this.api}/sucursales_despachos`,this.cabeceras_json).then((res)=>{
            this.dependencias = res.data.data;
          }).catch((e)=>{
            //console.log(e);
          });
        },

        async filtrarProveedores(search){
          await this.axios.get(`${this.api}/empresas?nombre=${search}&tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          ////console.log('search',search)
          ////console.log('col',col)
        },

        async cargar_datos(){
            //if(this.fechas[0] != null && this.fechas[0] != undefined){
                let body = {
                    desde:this.fechas[0],
                    hasta:this.fechas[1],
                    tipo_despacho_id:this.tipo_despacho_id,
                    empresas_ids:this.empresas_ids,
                    productos_ids:this.productos_ids,
                    dependencias_ids:this.dependencias_ids,
                    codigo_ticket:this.codigo_ticket,
                    numero_guia:this.numero_guia,
                    columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                        return {cabecera:c.label,path:c.path,tipo:c.tipo,ancho_excel:c.ancho_excel}
                    })
                }
                await this.axios.post(`${this.api}/reportes/despachos`,body,this.cabeceras_json).then(res=>{
                    //console.log(res.data.data);
                    this.datos = res.data.data.data;
                    this.total_resultado = res.data.data.total;
                    this.url_excel = res.data.data.url;
                }).catch(e=>{
                    //console.log(e);
                });
            //}
            
        },

        async exportar_excel(){
            window.open(this.url_excel, '_blank');
            /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                window.open(this.url_excel, '_blank');
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
        },

        async obtener_parametros_mp(){
            let body = {
                mp_tipos_id:this.mps_id
            }
            await this.axios.post(`${this.api}/reportes/personalizado/obtener_parametros_mp`,body,this.cabeceras_json).then((res)=>{
                this.mps_parametros = res.data.data
            }).catch((e)=>{
                console.log(e);
            })
        },

        devuelve_valor(item,path,tipo_dato){
          let keys = path.split('.');
          let valor = item;
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }
                  
          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fecha_hora(valor);
          }
          if(tipo_dato == 'date'){
            valor = this.$options.filters.fecha(valor);
          }
          if(tipo_dato == 'time'){
            valor = this.$options.filters.hora(valor);
          }
          return valor;
        },

        setearTodos(){
            this.columnas.forEach(c => {
                c.show = this.todos;
            });
        },

        abrirPdf(d){
            window.open(`${this.api_public}/guias/${d.url_guia}`, '_blank');
        },

        abrirDeclaracion(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.declaracion_jurada}`, '_blank');
        },

        abrirCam(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.cam}`, '_blank');
        },

        retornar_productos(){
            if(this.tipo_despacho_id == null){
                return [];
            }
            return this.productos.filter(p=>p.tipo_despacho_id == this.tipo_despacho_id);
        },
        retornar_sucursales(){
            if(this.empresas_ids == null){
                return [];
            }
            return this.dependencias.filter(d => d.empresas_id == this.empresas_ids);
            //return this.dependencias.filter(p=>p.tipo_despacho_id == this.tipo_despacho_id);
        },

        
    },
    computed:{

        mps_parametros_seleccionados(){
            let array = [];
            let parametros = []
            
            this.mps_parametros.forEach(mp => {
                mp.analisis.forEach(a => {
                    a.parametros.forEach(p => {
                        if(p.check){
                            parametros.push(p);
                        }
                    });
                });
            });

            /* this.mps_parametros.forEach(mp=>{
                let agregar = false;
                let analisis_array = [];
                mp.analisis.forEach(analisis => {
                    agregar = false;
                    let pars = parametros.filter(p=>p.lab_item_analisis_id == analisis.id);
                    if(pars.length > 0){
                        agregar = true;
                        analisis_array.push({
                            id:analisis.id,
                            nombre:analisis.nombre,
                            parametros:pars
                        });
                    }
                    
                });
                if(agregar){
                    array.push({
                        id:mp.id,
                        nombre:mp.nombre,
                        analisis:analisis_array
                    });
                }
            }) */
            return parametros;
        },

        ...mapState(['api','api_public','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; border: 1px solid rgb(212, 212, 212);}
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed{
    position: sticky; top: 0; z-index: 100;
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
/*th     { background:#427391; color:#fff }*/
.margen-1{
    margin: 0em 0.5em;
}

</style>